var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var types_2 = require("./types");
var operations_1 = require("../operations");
var byNamespace = function (state, action) {
    if (state === void 0) { state = {
        panes: []
    }; }
    switch (action.type) {
        case types_2.PanesActionTypes.INIT_PANES_NAMESPACE:
            return {
                panes: [{
                        id: action.payload.namespace,
                        isCurrent: true,
                        split: false,
                        splitAxis: types_1.PaneSplitAxis.Horizontal,
                        contents: [],
                        children: [],
                    }],
            };
        case types_2.PanesActionTypes.SET_CURRENT_PANE:
            return {
                panes: operations_1.setCurrentPane(state.panes, action.payload.paneId),
            };
        case types_2.PanesActionTypes.ADD_CONTENT_TO_CURRENT_PANE:
            return {
                panes: operations_1.addContentToCurrentPane(state.panes, action.payload.content),
            };
        case types_2.PanesActionTypes.SET_PANE_CURRENT_CONTENT:
            return {
                panes: operations_1.setPaneCurrentContent(state.panes, action.payload.paneId, action.payload.contentId),
            };
        case types_2.PanesActionTypes.REMOVE_PANE_CONTENT:
            return {
                panes: operations_1.removePaneContent(state.panes, action.payload.paneId, action.payload.contentId),
            };
        case types_2.PanesActionTypes.REMOVE_CONTENT_FROM_ALL_PANES:
            return {
                panes: operations_1.removeContentFromAllPanes(state.panes, action.payload.contentId),
            };
        case types_2.PanesActionTypes.SPLIT_PANE:
            return {
                panes: operations_1.splitPane(state.panes, action.payload.paneId, action.payload.axis),
            };
        default:
            return state;
    }
};
exports.panesReducer = function () { return function (state, action) {
    if (state === void 0) { state = {}; }
    var _a;
    switch (action.type) {
        case types_2.PanesActionTypes.INIT_PANES_NAMESPACE:
        case types_2.PanesActionTypes.SET_CURRENT_PANE:
        case types_2.PanesActionTypes.ADD_CONTENT_TO_CURRENT_PANE:
        case types_2.PanesActionTypes.SET_PANE_CURRENT_CONTENT:
        case types_2.PanesActionTypes.REMOVE_PANE_CONTENT:
        case types_2.PanesActionTypes.REMOVE_CONTENT_FROM_ALL_PANES:
        case types_2.PanesActionTypes.SPLIT_PANE:
            return __assign({}, state, (_a = {}, _a[action.payload.namespace] = byNamespace(state[action.payload.namespace], action), _a));
        default:
            return state;
    }
}; };
